import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import ObjectViewer from '../Common/ObjectViewer';
import Spinner from '../../layout/Spinner';

const Creative = () => {
  const dispatch = useDispatch();
  const { account_id, creative_id } = useParams();
  const { creative, video, pageAdVolume, loadingPageAdVolume } = useSelector((state) => state.general);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'creative',
        route: 'accountDashboard/getCreativeById',
        accountId: account_id,
        creativeId: creative_id,
      })
    );
  }, [dispatch, account_id, creative_id]);
  console.log({ creative, video, pageAdVolume });

  return (
    <div className='container mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <h3>Creative Overview</h3>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        <h5>
          Creative Data from Facebook <span className='text-primary'>getCreativeById(creativeId, token)</span>
        </h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        {creative?.id ? <ObjectViewer data={creative} /> : <Spinner />}
      </div>
      <div className='row d-flex justify-content-center align-items-center pt-lg-0 border-bottom'>
        {creative?.video_id ? (
          <>
            video_id:{' '}
            <button
              className='btn btn-outline-primary ml-2'
              onClick={() => {
                dispatch(
                  apiAction({
                    reduxField: 'video',
                    route: 'accountDashboard/getVideoById',
                    accountId: account_id,
                    videoId: creative.video_id,
                  })
                );
              }}
            >
              {creative.video_id}
            </button>
          </>
        ) : null}
      </div>
      <div className='row d-flex justify-content-center mt-4 align-items-center pt-lg-0 '>
        Page ID: {creative?.object_story_spec.page_id}
      </div>
      <div className='row d-flex justify-content-center mt-2 mb-2 align-items-center pt-lg-0'>
        <button
          className='btn btn-outline-primary ml-2'
          disabled={loadingPageAdVolume}
          onClick={() => {
            dispatch(generalSet({ reduxField: 'loadingPageAdVolume', value: true }));
            dispatch(
              apiAction({
                reduxField: 'pageAdVolume',
                route: 'accountDashboard/getAdVolumeForPage',
                accountId: account_id,
                pageId: creative?.object_story_spec.page_id,
                setLoading: 'loadingPageAdVolume',
              })
            );
          }}
        >
          Show Page Ad Volumne
        </button>
      </div>
      {pageAdVolume?.data && pageAdVolume.data[0].actor_id ? (
        <>
          <div className='row d-flex justify-content-center mt-2 mb-2 align-items-center pt-lg-0'>
            <span className='border p-3'>Actor ID: {pageAdVolume.data[0].actor_id}</span>
            <span className='border p-3'>
              ads_running_or_in_review_count: {pageAdVolume.data[0].ads_running_or_in_review_count}
            </span>
            <span className='border p-3'>
              current_account_ads_running_or_in_review_count:{' '}
              {pageAdVolume.data[0].current_account_ads_running_or_in_review_count}
            </span>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default Creative;
